import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { IMarkdownLinkObject, parseMarkdownLink } from 'app/shared/lib/utilities';

@autoinject()
export class EssMarkdown extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable({ changeHandler: 'updateMarkdownLinkObject' })
    protected value: string | null = null;

    @bindable({ changeHandler: 'updateMarkdownLinkObject' })
    protected tooltipHeader: string | null = null;

    private markdownLinkObject?: IMarkdownLinkObject;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////
    protected updateMarkdownLinkObject(): void {
        this.markdownLinkObject = parseMarkdownLink(this.value);
        // if markdown is invalid, check if text contains a URL pattern
        if(this.markdownLinkObject.hasError && this.hasURLFormat(this.markdownLinkObject.text)) {
            this.markdownLinkObject = {
                hasError: false,
                text: this.markdownLinkObject.text,
                title: '',
                url: this.markdownLinkObject.text,
            };
        }
        if(!this.markdownLinkObject.hasError) {
            // generate tooltip based on the tooltipHeader binding + title derived from markup + the url
            let newTitle = '';
            const { title, url } = this.markdownLinkObject;
            if(this.tooltipHeader) newTitle += `${this.tooltipHeader}: `;
            if(title) newTitle += `${title}: `;
            if(url) newTitle += url;
            this.markdownLinkObject.title = newTitle;
        }
    }

    ////****************** Functions ************************************************////
    protected hasURLFormat(text: string): boolean {
        const OPTIONS = ['http', 'https'];
        return OPTIONS.findIndex(o => text.indexOf(o + '://') === 0) >= 0;
    }

    ////****************** Service Calls ********************************************////

}
